import api from './api';

export interface Application {
  id: number;
  name: string;
  identifier: string;
  platform: 'iOS' | 'Android' | 'Windows' | 'macOS' | 'Linux' | 'Web';
  status: 'Active' | 'Development' | 'Deprecated';
  description?: string;
  createdBy?: number;
  createdByName?: string;
  updatedBy?: number;
  updatedByName?: string;
  createdAt: string;
  updatedAt: string;
}

export const applicationService = {
  getList: (search?: string) => api.get('/applications', { params: { search } }),
  getOne: (id: number) => api.get(`/applications/${id}`),
  create: (data: Partial<Application>) => api.post('/applications', data),
  update: (id: number, data: Partial<Application>) => api.put(`/applications/${id}`, data),
  delete: (id: number) => api.delete(`/applications/${id}`),
  getStats: () => api.get('/applications/stats'),
};
